



export const isMobileDevice = () => {

  if (navigator.userAgentData && navigator.userAgentData.mobile) {
    return true;
  }

  const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (screenWidth <= 992) {

    return true;
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileUserAgents = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  for (const mobileUserAgent of mobileUserAgents) {
    if (mobileUserAgent.test(userAgent)) {
      return true;
    }
  }

  return false;
}






export const cacheImageToLocalStorage = async (imgPath, key, expirationDays = 7) => {
  try {
      const cachedImage = getCachedImage(key);
      if (cachedImage) return cachedImage;

      const response = await fetch(imgPath);
      const blob = await response.blob();

      return new Promise((resolve) => {
          const reader = new FileReader();

          reader.onloadend = () => {
              const imageData = {
                  data: reader.result,
                  expiry: Date.now() + (expirationDays * 24 * 60 * 60 * 1000)
              };

              localStorage.setItem(key, JSON.stringify(imageData));
              resolve(reader.result);
          };

          reader.onerror = () => resolve(imgPath);
          reader.readAsDataURL(blob);
      });
  } catch (error) {
      console.error(`Failed to cache image ${key}:`, error);
      return imgPath;
  }
};


export const getCachedImage = (key) => {
  try {
      const cachedData = localStorage.getItem(key);
      if (!cachedData) return null;

      const imageData = JSON.parse(cachedData);

      if (imageData.expiry && imageData.expiry < Date.now()) {
          localStorage.removeItem(key);
          return null;
      }

      return imageData.data;
  } catch (error) {
      console.error(`Error retrieving cached image ${key}:`, error);
      return null;
  }
};

export const preloadImages = async (imageConfigs) => {
  if (!imageConfigs || !imageConfigs.length) return;

  const loadImagesWithDelay = imageConfigs.map((config, index) =>
      new Promise(resolve => {
          const delay = index < 4 ? 0 : index * 50;
          setTimeout(() => {
              cacheImageToLocalStorage(config.path, config.key)
                  .then(resolve)
                  .catch(() => resolve(null));
          }, delay);
      })
  );

  await Promise.all(loadImagesWithDelay);
};

export const preloadCriticalImages = (imagePaths) => {
  imagePaths.forEach(path => {
    const img = new Image();
    img.src = path;
  });
};
// module.exports = { isMobileDevice };